module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/services02-6686711e8508e3624a306dff096901a8.jpg";